<template>
    <div class="view magazine mb-0 pb-50" id="canvas-magazine">
        <div class="container-fluid" style="padding: 0px 100px; min-height: 100vh;">
            <app-magazine-filter class="text-center pt-30" @filterChanged="redrawComponents()"></app-magazine-filter>
            <div class="row mt-30" v-if="notAuthorized">
                <div class="col-12">
                    <h4 class="not-allowed-text">You are not authorized to view this page</h4>
                </div>
            </div>
            <div class="row mt-30">
                <div class="col-6">
                    <el-card class="box-card" v-if="chartsLoaded && tablesLoaded" v-loading="loading" element-loading-text="Loading data" element-loading-spinner="el-icon-loading">
                        <div slot="header" class="text-left">
                            <h3 class="inline">{{hoursChart.title}}</h3>
                            <!-- <p class="ytd-index"><span style="color: red" v-if="hoursChart.index > 0">+</span><span :style="hoursChart.index < 0 ? {'color': 'green'} : {'color': 'red'}">{{hoursChart.index * 100}}%</span></p> -->
                        </div>
                        <bar-chart :height="300" :chartData="hoursChart.data" :options="hoursChart.options"></bar-chart>
                        <el-table :cell-style="cellStyle" :data="hoursTable.data" class="mt-30">
                            <el-table-column
                                v-for="h in hoursTable.headers"
                                :prop="h.prop"
                                :label="h.label"
                                :key="h.prop"
                            >
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
                <div class="col-6">
                    <el-card class="box-card" v-if="chartsLoaded && tablesLoaded" v-loading="loading" element-loading-text="Loading data" element-loading-spinner="el-icon-loading">
                        <div slot="header" class="text-left">
                            <h3 class="inline">{{revenueChart.title}}</h3>
                            <!-- <p class="ytd-index"><span style="color: green" v-if="revenueChart.index > 0">+</span><span :style="revenueChart.index < 0 ? {'color': 'red'} : {'color': 'green'}">{{revenueChart.index * 100}}%</span></p> -->
                        </div>
                        <bar-chart :height="300" :chartData="revenueChart.data" :options="revenueChart.options"></bar-chart>
                        <el-table :cell-style="cellStyle" :data="revenueTable.data" class="mt-30">
                            <el-table-column
                                v-for="h in revenueTable.headers"
                                :prop="h.prop"
                                :label="h.label"
                                :key="h.prop"
                                :formatter="formatter"
                            >
                            </el-table-column>
                        </el-table>
                    </el-card>
                </div>
            </div>

            <div class="row mt-30">
                <div class="col-6">
                    <el-card class="box-card" v-if="compassLoaded" style="height: 500px;" v-loading="loading" element-loading-text="Loading data" element-loading-spinner="el-icon-loading">
                        <div slot="header" class="text-left">
                            <h3>{{compass.title}}</h3>
                        </div>
                        <div class="row">
                            <div class="col-6">
                                <div class="compass">
                                    <p class="compass-title">{{compass.titles[0]}}</p>
                                    <v-gauge :value="compass.data[0]" :maxValue="150" :minValue="50" top :unit="compass.index_all_stores[0]" :options="compass.options[0]"></v-gauge>
                                    <p class='compass-title'>{{compass.data[0]}}</p>
                                    <p class="compass-subtitle">{{compass.index_all_stores[0]}}</p>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="compass">
                                    <p class="compass-title">{{compass.titles[1]}}</p>
                                    <v-gauge :value="compass.data[1]" :maxValue="150" :minValue="50" top :unit="compass.index_all_stores[1]" :options="compass.options[0]"></v-gauge>
                                    <p class="compass-title">{{compass.data[1]}}</p>
                                    <p class="compass-subtitle">{{compass.index_all_stores[1]}}</p>
                                </div>
                            </div>
                            <p class="compass-legend">Score = (cost / revenue) / (cost LY / revenue LY)</p>
                        </div>
                    </el-card>
                </div>
                <div class="col-6">
                    <el-card class="box-card" v-if="costBreakdownLoaded" style="height: 500px;" v-loading="loading" element-loading-text="Loading data" element-loading-spinner="el-icon-loading">
                        <div slot="header" class="text-left">
                            <h3 class="inline">{{costBreakdown.title}}</h3>
                            <p class="ytd-index"><span :style="costBreakdown.index < 100 ? {'color': 'green'} : {'color': 'red'}">{{costBreakdown.index}}%</span></p>
                        </div>
                        <bar-chart id="test123" :chartData="costBreakdown.data" :options="costBreakdown.options"></bar-chart>
                    </el-card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { getHeadersWithAccessToken, colors, formatString, headers } from '@/functions.js'
import axios from 'axios'
import BarChart from '@/chart/BarChart.js'
import MagazineFilter from '@/components/MagazineFilter.vue'
// import GraphFilter from '@/components/GraphFilter'
const hexToRgbA = function (hex, opacity) {
    var c
    if (/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)) {
        c = hex.substring(1).split('')
        if (c.length === 3) {
            c = [c[0], c[0], c[1], c[1], c[2], c[2]]
        }
        c = '0x' + c.join('')
        return 'rgba(' + [(c >> 16) & 255, (c >> 8) & 255, c & 255].join(',') + ',' + opacity + ')'
    } else { return hex }
}

export default {
    data () {
        return {
            hoursChart: {},
            revenueChart: {},
            chartsLoaded: false,
            hourstable: {},
            revenueTable: {},
            tablesLoaded: false,
            compass: {},
            compassLoaded: false,
            costBreakdown: {},
            costBreakdownLoaded: false,
            notAuthorized: false,
            loading: true
        }
    },
    components: {
        BarChart,
        appMagazineFilter: MagazineFilter
    },
    computed: {
        userLoggedIn () {
            return this.$auth.isAccessTokenValid()
        }
    },
    methods: {
        plotChart (data, hours = false) {
            let datasets = []
            if (hours === true) {
                let obj1 = { 'label': 'Hours', 'backgroundColor': Array.from({ length: data.data.length }).fill(hexToRgbA(colors[1], 0.3)), 'borderColor': Array.from({ length: data.data.length }).fill(hexToRgbA(colors[1], 1)), 'borderWidth': 2, 'data': data.data.map(x => x.hours) }
                let obj2 = { 'type': 'line', 'fill': false, 'label': 'Hours budget', 'backgroundColor': hexToRgbA(colors[0], 0.3), 'borderColor': hexToRgbA(colors[0], 1), 'data': data.data.map(x => x.hours_budget) }
                datasets.push(obj2)
                datasets.push(obj1)
            } else {
                let obj1 = { 'label': 'Revenue', 'backgroundColor': Array.from({ length: data.data.length }).fill(hexToRgbA(colors[1], 0.3)), 'borderColor': Array.from({ length: data.data.length }).fill(hexToRgbA(colors[1], 1)), 'borderWidth': 2, 'data': data.data.map(x => x.revenue) }
                let obj2 = { 'type': 'line', 'fill': false, 'showLine': true, 'label': 'Revenue Budget', 'backgroundColor': hexToRgbA(colors[0], 0.3), 'borderColor': hexToRgbA(colors[0], 1), 'data': data.data.map(x => x.revenue_budget) }
                datasets.push(obj2)
                datasets.push(obj1)
            }
            let labels = data.data.map(x => x.x_label)
            let scales = { 'yAxes': [{ ticks: { min: 0 }, stacked: false, display: true, scaleLabel: { display: true, labelString: formatString(data.yaxis) }, id: 'A', position: 'left' }], 'xAxes': { stacked: false, label: '' } }
            return {
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true
                    },
                    scales: {
                        xAxes: scales.xAxes,
                        yAxes: scales.yAxes
                    },
                    tooltips: {
                        enabled: true,
                        callbacks: {
                        }
                    }
                },
                'title': formatString(data.title),
                'index': data.index
            }
        },

        fillTable (data, hours = false) {
            let keys = []
            for (let item of Object.keys(data.rows[0])) {
                keys.push({ 'prop': item, 'label': formatString(item) })
            }

            let tableData = data.rows
            for (let item of tableData) {
                if (Object.keys(item).includes('variable')) {
                    item['variable'] = formatString(item['variable'])
                }
            }
            return {
                headers: keys,
                data: tableData,
                title: formatString(data.title)
            }
        },

        makeCompass (data) {
            // let options = { animationSpeed: 32, angle: 11, lineWidth: 25, radiusScale: 98, 'pointer.length': 57, 'pointer.color': '#000000', 'pointer.strokeWidth': 66, fontSize: 24, colorStart: '#6FADCF', colorStop: '#8FC0DA', strokeColor: '#E0E0E0', divisions: 10, divLength: 100, divColor: '#333333', divWidth: 10, subDivisions: 5, subLength: 50, subColor: '#66666', subWidth: 6 }
            let options = {
                angle: 0.11, // The span of the gauge arc
                lineWidth: 0.25, // The line thickness
                radiusScale: 1, // Relative radius
                pointer: {
                    length: 0.57, // // Relative to gauge radius
                    strokeWidth: 0.066, // The thickness
                    color: '#000000' // Fill color
                },
                limitMax: false, // If false, max value increases automatically if value > maxValue
                limitMin: false, // If true, the min value of the gauge will be fixed
                colorStart: '#6FADCF', // Colors
                colorStop: '#8FC0DA', // just experiment with them
                strokeColor: '#E0E0E0', // to see which ones work best for you
                generateGradient: true,
                highDpiSupport: true, // High resolution support
                // renderTicks is Optional
                renderTicks: {
                    divisions: 10,
                    divWidth: 1,
                    divLength: 1,
                    divColor: '#333333',
                    subDivisions: 5,
                    subLength: 0.5,
                    subWidth: 0.7,
                    subColor: '#666666'
                },
                staticZones: [
                    { strokeStyle: '#30B32D', min: 50, max: 90 },
                    { strokeStyle: '#FFDD00', min: 90, max: 110 },
                    { strokeStyle: '#F03E3E', min: 110, max: 150 }
                ],
                staticLabels: {
                    font: '10px sans-serif', // Specifies font
                    labels: [60, 80, 100, 120, 140], // Print labels at these values
                    color: '#000000', // Optional: Label text color
                    fractionDigits: 0 // Optional: Numerical precision. 0=round off.
                }
            }

            return {
                'title': formatString(data.title),
                'titles': [formatString(data.data[0].x_label), formatString(data.data[1].x_label)],
                'data': [data.data[0].cost_index, data.data[1].cost_index],
                'options': [options, options],
                'index_all_stores': ['All stores: ' + String(data.data[0].index_all_stores) + '', 'All stores: ' + String(data.data[1].index_all_stores) + '']
            }
        },

        makeCostBreakdown (total, detail) {
            let datasets = []
            let i = 0
            for (let item of detail.data) {
                if (item.employee_function.substring(0, 4) !== 'line' && item.employee_function !== 'total') {
                    let obj1 = { maxBarThickness: 100, stack: 'Stack 1', 'label': item.employee_function, 'backgroundColor': hexToRgbA(colors[i], 0.3), 'borderColor': hexToRgbA(colors[i], 1), 'borderWidth': 2, 'data': [item.share_ly * 100, item.share_ytd * 100] }
                    datasets.push(obj1)
                    i += 1
                }
                if (item.employee_function.substring(0, 4) === 'line') {
                    let obj1 = { type: 'line', 'label': item.employee_function, fill: false, 'backgroundColor': hexToRgbA('#333333', 0.3), 'borderColor': hexToRgbA('#333333', 0.5), 'borderWidth': 2, 'data': [item.share_ly * 100, item.share_ytd * 100] }
                    datasets.push(obj1)
                    i += 1
                }
            }
            let labels = ['LY', 'YTD']
            let scales = { 'yAxes': [{ ticks: { beginAtZero: true }, stacked: true, display: true, scaleLabel: { display: true, labelString: formatString(detail.yaxis) + ' (%)' } }], 'xAxes': [{ stacked: true, label: '' }] }
            return {
                data: {
                    labels: labels,
                    datasets: datasets
                },
                options: {
                    responsive: true,
                    maintainAspectRatio: false,
                    legend: {
                        display: true,
                        labels: {
                            filter: function (item, chart) {
                                // Logic to remove a particular legend item goes here
                                return !item.text.includes('line')
                            }
                        }
                    },
                    scales: {
                        xAxes: scales.xAxes,
                        yAxes: scales.yAxes
                    },
                    tooltips: {
                        enabled: true,
                        callbacks: {
                        }
                    }
                },
                'title': formatString(detail.title),
                'index': total.data[0].total_index
            }
        },
        redrawComponents () {
            this.loading = true
            let params = {
                'store_id': this.$store.state.magazine.stores,
                'year': this.$store.state.magazine.year,
                'week': this.$store.state.magazine.week,
                'period_amount': this.$store.state.magazine.amount !== undefined ? this.$store.state.magazine.amount : 8
            }
            if (Object.keys(this.$route.query).includes('token')) {
                params['token'] = this.$route.query['token']
            }
            let stopQuery = false
            for (let item in params) {
                if (params[item] === undefined || params[item] === 'undefined') {
                    stopQuery = true
                }
            }
            if (stopQuery === false) {
                axios.post(((this.$store.state.general.devMode === true) ? process.env.VUE_APP_MAGAZINE_API_BASE_URL_DEV : process.env.VUE_APP_MAGAZINE_API_BASE_URL) + '/magazine_week_1', params, { headers: this.userLoggedIn ? getHeadersWithAccessToken() : headers })
                    .then(response => {
                        this.hoursChart = this.plotChart(response.data.data.hrsgraph, true)
                        this.revenueChart = this.plotChart(response.data.data.revgraph)
                        this.hoursTable = this.fillTable(response.data.data.hrstable, true)
                        this.revenueTable = this.fillTable(response.data.data.revtable)
                        this.chartsLoaded = true
                        this.tablesLoaded = true
                        this.compass = this.makeCompass(response.data.data.compass)
                        this.compassLoaded = true
                        this.costBreakdown = this.makeCostBreakdown(response.data.data.cost_total, response.data.data.cost_detail)
                        this.costBreakdownLoaded = true
                        this.loading = false
                    })
                    .catch(error => {
                        if (error.response.status === 422 || error.response.status === 401) {
                            this.notAuthorized = true
                            this.loading = false
                        }
                    })
            }
        },
        formatter (row, column) {
            // Formatter for the el-table
            if (row[column.property] !== undefined) {
                if (row.variable.includes('index') === false && column.property !== 'variable') {
                    return '€' + row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 2 })
                } else {
                    return row[column.property].toLocaleString('en-EN', { maximumFractionDigits: 2 })
                }
            }
        },
        cellStyle (data) {
            let totalColIndex = parseInt(this.$store.state.magazine.amount) + 1
            if (data.columnIndex === totalColIndex) {
                return { 'background-color': '#EBEEF5' }
            }
        }
    },
    created () {
    }
}
</script>

<style lang="scss">
.magazine {
    background-color: #1D778E;
    .el-card {
        border-radius: 15px;
    }
    .col-6 {
        padding-right: 15px;
        padding-left: 15px;
    }
    .compass {
        margin: 0 auto;
    }
    p.ytd-index {
        float: right;
        display: inline;
        margin-bottom: 0px !important;
        margin-top: 5px;
    }
    .gauge-title {
        display: none;
    }
    p.compass-title {
        margin-bottom: 0px;
        font-weight: 800;
        font-size: 18px;
    }
    p.compass-subtitle {
        margin-bottom: 0px;
        font-size: 14px;
    }
    p.compass-legend {
        margin-bottom: 0px;
        margin-top: 100px;
        font-size: 12px;
    }
    .el-loading-spinner {
        margin-top: 0px;;
    }
    .el-loading-spinner .el-loading-text {
        font-size: 16px;
    }
    .el-loading-mask {
        display: block;
    }
    .el-icon-loading {
    }
    h4.not-allowed-text {
        color: #ffffff;
    }
}
</style>
